import { TextField } from '@material-ui/core'

const ReduxTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}: any) => (
  <TextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    {...custom}
    // overWrite helperText if validation fails
    helperText={touched && error ? touched && error : custom.helperText}
    {...input}
  />
)

export default ReduxTextField
